//import OT from "@opentok/client";
//import { isNaN } from "es-toolkit/compat";

import type { VideoCallConfig } from "../Components/definitions";

import { LocalStorageNamespace } from "@/Modules/App/Models/Localstorage/LocalStorageNamespace";

import { LocalStorageService } from "@/Services/LocalStorageService";

import { isValidString } from "@/Utils/String";
//import { danger, log } from "@/Utils/Debug";
//import { hasValue } from "@/Utils/Objects";
import { getNowInSeconds } from "@/Utils/Date";

//const LIMIT_VALID_CONFIG_TIME = DAY_IN_SECONDS; // One day in secs

enum CONFIG_TAG {
  VIDEO = "videoId",
  AUDIO = "audioId",
  OUTPUT = "outputId",
  UPDATED_AT = "updatedAt",
  MIRROR = "mirror",
  BLUR = "blur",
  VIDEO_ACTIVE = "video",
  AUDIO_ACTIVE = "audio",
}

const videoCallStorageService: LocalStorageService = new LocalStorageService(
  LocalStorageNamespace.VIDEO_CALL
);

const setValue = (tag: CONFIG_TAG, val: unknown) => {
  videoCallStorageService.set(tag, val);
};

const getValue = (tag: CONFIG_TAG): unknown => {
  return videoCallStorageService.get(tag);
};

export const SaveVideoCallConfigActionHandler = (config: VideoCallConfig) => {
  setValue(CONFIG_TAG.VIDEO, config.videoId);
  setValue(CONFIG_TAG.AUDIO, config.audioId);
  setValue(CONFIG_TAG.OUTPUT, config.outputId);
  setValue(CONFIG_TAG.BLUR, config.blur);
  setValue(CONFIG_TAG.MIRROR, config.mirror);
  setValue(CONFIG_TAG.VIDEO_ACTIVE, config.video);
  setValue(CONFIG_TAG.AUDIO_ACTIVE, config.audio);
  setValue(CONFIG_TAG.UPDATED_AT, getNowInSeconds());
};

export const ClearVideoCallConfigActionHandler = () => {
  videoCallStorageService.clear();
};

export const GetVideoCallConfigActionHandler = (): VideoCallConfig | undefined => {
  const videoId = getValue(CONFIG_TAG.VIDEO) as string | undefined;
  const audioId = getValue(CONFIG_TAG.AUDIO);
  const outputId = getValue(CONFIG_TAG.OUTPUT) as string | undefined;
  const mirror = getValue(CONFIG_TAG.MIRROR) as boolean | undefined;
  const blur = getValue(CONFIG_TAG.BLUR) as "low" | "high" | false;
  const video = getValue(CONFIG_TAG.VIDEO_ACTIVE) as boolean;
  const audio = getValue(CONFIG_TAG.AUDIO_ACTIVE) as boolean;

  if (isValidString(audioId)) {
    return { videoId, audioId, outputId, mirror, blur, audio, video };
  }

  return undefined;
};

export const IsValidVideoCallConfigActionHandler = (): Promise<boolean> => {
  return Promise.resolve(false);

  // Check if config is valid and not expired
  /*return new Promise<boolean>((resolve) => {
    const config = GetVideoCallConfigActionHandler();

    if (!hasValue(config)) {
      danger("VIDEOCALL: No config");
      resolve(false);

      return;
    }

    if (!isValidString(config.updatedAt)) {
      danger("VIDEOCALL: Invalid date config");
    } else {
      let updatedAt: number = 0;

      try {
        updatedAt = parseInt(config.updatedAt);
      } catch (e) {
        danger("VIDEOCALL: Invalid date config", e);
        updatedAt = 0;
      }

      if (isNaN(updatedAt) || updatedAt === 0) {
        resolve(false);

        return;
      } else if (updatedAt + LIMIT_VALID_CONFIG_TIME < getNowInSeconds()) {
        resolve(false);

        return;
      }
    }

    OT.getDevices((error, devices) => {
      if (error || !hasValue(devices) || devices.length === 0) {
        danger("VIDEOCALL: Error getting devices for check config", error);
        resolve(false);

        return;
      }

      const audioDevice = devices.find((device) => device.deviceId === config.audioId);

      if (!hasValue(audioDevice)) {
        danger("VIDEOCALL: No audio config device found");
        resolve(false);

        return;
      }

      if (hasValue(config.videoId)) {
        log("VIDEOCALL: Current VideoId", config.videoId);

        const videoDevice = devices.find((device) => device.deviceId === config.videoId);

        if (!hasValue(videoDevice)) {
          danger("VIDEOCALL: No video config device found");
          resolve(false);

          return;
        }
      }

      if (hasValue(config.outputId)) {
        danger("VIDEOCALL: Defualt OutputId", config.outputId);

        OT.getAudioOutputDevices()
          .then((outputDevices) => {
            const outputDevice = outputDevices.find((device) => device.deviceId === config.outputId);

            if (!hasValue(outputDevice)) {
              danger("VIDEOCALL: No output config device found");
              resolve(false);

              return;
            }

            resolve(true);
          })
          .catch(() => {
            resolve(false);
          });
      } else {
        resolve(true);
      }
    });

    resolve(true);
  });*/
};

export default {
  SaveActionHandler: SaveVideoCallConfigActionHandler,
  ClearActionHandler: ClearVideoCallConfigActionHandler,
  GetActionHandler: GetVideoCallConfigActionHandler,
  IsValidActionHandler: IsValidVideoCallConfigActionHandler,
};
